<template>
  <pnet-validation-observer>
    <div class="container">
      <div v-for="(rangeValueFlex, index) in nestedRangeValuesFlex" v-bind:key="index">
        <div class="row">

          <!-- label -->
          <label class="col" for
            v-if="(rangeValueFlex.label !== undefined && !isEmptyOrSpaces(rangeValueFlex.label)) ||
                   (nestedRangeValuesFlex[0].label !== undefined && !isEmptyOrSpaces(nestedRangeValuesFlex[0].label))">
            <small>{{rangeValueFlex.label}}</small>
          </label>

          <!-- from -->
          <div class="col" v-if="rangeValueFlex.from !== undefined && rangeValueFlex.fromSignLeft">
            <text-field v-model="rangeValueFlex.fromSign"></text-field>
          </div>
          <div class="col" v-if="rangeValueFlex.from !== undefined">
            <text-field v-model="rangeValueFlex.from"></text-field>
          </div>
          <div class="col" v-if="rangeValueFlex.from !== undefined && !rangeValueFlex.fromSignLeft">
            <text-field v-model="rangeValueFlex.fromSign"></text-field>
          </div>

          <!-- from-to operator -->
          <label for v-if="rangeValueFlex.fromToOperator !== undefined">
            <small>{{rangeValueFlex.fromToOperator}}</small>
          </label>

          <!-- to -->
          <div class="col" v-if="rangeValueFlex.to !== undefined && rangeValueFlex.toSignLeft" >
            <text-field v-model="rangeValueFlex.toSign"></text-field>
          </div>
          <div class="col" v-if="rangeValueFlex.to !== undefined">
            <text-field v-model="rangeValueFlex.to"></text-field>
          </div>
          <div class="col" v-if="rangeValueFlex.to !== undefined && !rangeValueFlex.toSignLeft">
            <text-field v-model="rangeValueFlex.toSign"></text-field>
          </div>

          <!-- to-value operator -->
          <label for v-if="rangeValueFlex.toValueOperator !== undefined && showValue">
            <small>{{rangeValueFlex.toValueOperator}}</small>
          </label>

          <!-- value -->
          <div class="col" v-if="rangeValueFlex.valueSign !== undefined && rangeValueFlex.valueSignLeft && showValue">
            <text-field v-model="rangeValueFlex.valueSign"></text-field>
          </div>
          <div class="col" v-if="rangeValueFlex.value !== undefined && showValue">
            <text-field v-model="rangeValueFlex.value"></text-field>
          </div>
          <div class="col" v-if="rangeValueFlex.valueSign !== undefined && !rangeValueFlex.valueSignLeft && showValue">
            <text-field v-model="rangeValueFlex.valueSign"></text-field>
          </div>
        </div>
        <div class="row">
          <range-values-flex
            :label="labelL2"
            :fromSign="fromSignL2"
            :fromSignLeft="fromSignLeftL2"
            :toSign="toSignL2"
            :toSignLeft="toSignLeftL2"
            :showValue="showValueL2"
            :valueSign="valueSignL2"
            :valueSignLeft="valueSignLeftL2"
            :fromToOperator="fromToOperatorL2"
            :toValueOperator="toValueOperatorL2"
            v-model="rangeValueFlex.rangeValuesFlex"
          ></range-values-flex>
        </div>
      </div>
      <div class="col-12 pt-3 pb-3">
        <div class="filtri mb-4">
          <div class="col-12 col-md-4 col-lg-12" align="left">
            <button class="btn btn-primary mt-4 p-1 pl-3 pr-3" v-on:click.prevent="inserisci">+</button>
            <button
              v-if="nestedRangeValuesFlex.length > 1"
              class="btn btn-primary mt-4 p-1 pl-3 pr-3"
              v-on:click.prevent="cancella"
            >-</button>
          </div>
        </div>
      </div>
    </div>
  </pnet-validation-observer>
</template>

<script lang="js">
import Vue from "vue";
import RangeValuesFlex from "@/components/RangeValuesFlex.vue";
import TextField from "@/components/TextField.vue";
import { clone , equals } from "ramda";
export default Vue.extend({
  props: ["value",
    "label",
    "fromSign",
    "fromSignLeft",
    "toSign",
    "toSignLeft",
    "showValue",
    "valueSign",
    "valueSignLeft",
    "fromToOperator",
    "toValueOperator",
    "labelL2",
    "fromSignL2",
    "fromSignLeftL2",
    "toSignL2",
    "toSignLeftL2",
    "showValueL2",
    "valueSignL2",
    "valueSignLeftL2",
    "fromToOperatorL2",
    "toValueOperatorL2",
  ],
  components: {
    RangeValuesFlex,
    TextField
  },
  data: function() {
    return {
      nestedRangeValuesFlex: []
    }},
  methods: {
    inserisci: function() {
      this.nestedRangeValuesFlex.push({
        order: this.nestedRangeValuesFlex.length,
        label: this.label,
        from: "",
        fromSign: this.fromSign,
        fromSignLeft: this.fromSignLeft,
        fromToOperator: this.fromToOperator,
        to: "",
        toSign: this.toSign,
        toSignLeft: this.toSignLeft,
        toValueOperator: this.toValueOperator,
        showValue: this.showValue,
        value: "",
        valueSign: this.valueSign,
        valueSignLeft: this.valueSignLeft,
        rangeValuesFlex: [
          {
            order: 0,
            label: this.labelL2,
            from: "",
            fromSign: this.fromSignL2,
            fromSignLeft: this.fromSignLeftL2,
            fromToOperator: this.fromToOperatorL2,
            to: "",
            toSign: this.toSignL2,
            toSignLeft: this.toSignLeftL2,
            toValueOperator: this.toValueOperatorL2,
            showValue: this.showValueL2,
            value: "",
            valueSign: this.valueSignL2,
            valueSignLeft: this.valueSignLeftL2,
          }
        ]
      });
    },
    cancella: function() {
      this.nestedRangeValuesFlex.pop();
    },
    isEmptyOrSpaces(str) {
      return str === null || str.match(/^ *$/) !== null;
    }
  },
  watch: {
    value: {
      deep: true,
      handler(newVal, oldVal) {
        if (!equals(newVal,oldVal)) {
          Vue.set(this, 'nestedRangeValuesFlex', clone(this.value));
        }
      }
    },
    nestedRangeValuesFlex: {
      deep: true,
      handler(newVal, oldVal) {
        if (!equals(newVal, oldVal)) {
          this.$emit('input', this.nestedRangeValuesFlex);
        }
      }
    }
  },
  mounted() {
    this.nestedRangeValuesFlex = clone(this.value);
  }
});
</script>
